import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { useContext, useState } from "react";
import { log } from "../monitoring/log";
import { addTnplProductToCart } from "./add-product";
import { TryFirstContext } from "./context";

export function TryFirstButton() {
  const context = useContext(TryFirstContext);
  const [isLoading, setIsLoading] = useState(false);

  if (!context) {
    throw new Error("TryFirstButton must be used within a TryFirstProvider");
  }

  // Only render the button when state is READY
  if (context.state !== "READY") {
    return null;
  }

  const handleTryFirstClick = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    event.stopPropagation();

    const { productForm, sellingPlanId, autocheck } = context;

    setIsLoading(true);

    try {
      await addTnplProductToCart({ autocheck, productForm, sellingPlanId });
    } catch (error) {
      console.error("Try First: Error adding to cart", error);
      log("Try First: Failed to add to cart", { error });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div data-target="try-first-button-container">
      <style dangerouslySetInnerHTML={{ __html: genTryFirstCss() }} />
      <div data-target="try-first-button-and-text">
        <RedoButton
          disabled={isLoading}
          hierarchy="secondary"
          onClick={handleTryFirstClick}
          pending={isLoading}
          size="md"
          text="Try before you buy"
          theme="normal"
        />
        <div data-target="try-first-disclaimer">
          Try at home for 10 days. Only pay for what you keep.
        </div>
      </div>
    </div>
  );
}

const genTryFirstCss = () => {
  // TODO: gen from Autocheck
  return `
    [data-target="try-first-button-container"] {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    
    [data-target="try-first-button-and-text"] {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    [data-target="try-first-disclaimer"] {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #aaaaaa;
    }
  `;
};
